import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { KOALA } from 'HubStyleTokens/colors';
import { CHEVRON_FONT_SIZE, INPUT_DEFAULT_HEIGHT, MERCURY_LAYER } from 'HubStyleTokens/sizes';
import { BASE_FONT_COLOR } from 'HubStyleTokens/theme';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
const horizontalFletching = css(["width:50%;height:100%;top:0;"]);
const verticalFletching = css(["width:110%;height:50%;left:-5%;"]);
const positionStyles = {
  top: css(["", ";bottom:0;transform:skew(-30deg);"], verticalFletching),
  bottom: css(["", ";top:0;transform:skew(30deg);"], verticalFletching),
  left: css(["", ";left:0;transform:skew(0deg,24deg);"], horizontalFletching),
  right: css(["", ";right:0;transform:skew(0deg,-24deg);"], horizontalFletching)
};

const makeFletching = position => css(["position:absolute;background-color:currentColor;content:' ';", ";"], positionStyles[position]);

const Outer = styled.span.withConfig({
  displayName: "UIChevron__Outer",
  componentId: "jwi843-0"
})(["align-items:center;display:inline-flex;font-size:", ";color:", ";min-height:", ";min-width:", ";padding:4px;padding-left:", ";position:relative;text-align:center;justify-content:center;&::before{", ";}&::after{", ";}"], CHEVRON_FONT_SIZE, KOALA, ({
  direction
}) => direction === 'down' ? '60px' : INPUT_DEFAULT_HEIGHT, ({
  direction
}) => direction === 'down' && '60px', ({
  direction
}) => direction !== 'down' && '12px', ({
  direction
}) => makeFletching(direction === 'down' ? 'left' : 'top'), ({
  direction
}) => makeFletching(direction === 'down' ? 'right' : 'bottom'));
const Inner = styled.span.withConfig({
  displayName: "UIChevron__Inner",
  componentId: "jwi843-1"
})(["color:", ";min-width:30px;position:relative;z-index:", ";"], BASE_FONT_COLOR, MERCURY_LAYER);
export default function UIChevron(props) {
  const {
    children
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["children"]);

  return /*#__PURE__*/_jsx(Outer, Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(Inner, {
      children: children
    })
  }));
}
UIChevron.propTypes = {
  children: PropTypes.node,
  direction: PropTypes.oneOf(['right', 'down'])
};
UIChevron.defaultProps = {
  direction: 'right'
};
UIChevron.displayName = 'UIChevron';